module.exports = __webpack_public_path__ + "static/media/anage-social@2x.0cf8fb5c.png";